import { Input } from "components/common/Input/Input";
import { useSize } from "./useSize";
import { Translate } from "components/common/Translate/Translate";
import { roundDimension } from "store/features/resizeEditor/utils/roundDimension";
import { ToolTip } from "@/components/common/ToolTip/ToolTip";
import { capitalize } from "@/utils/capitalize";
import { translateFunc } from "@/utils/translateFunc";
import { LockIcon, UnlockIcon } from "lucide-react";
import { Checkbox } from "@/components/common/Checkbox/Checkbox";

export const SizeForSocialMedia = () => {
    const { height, width, handleHeightChange, handleWidthChange, isLocked, toggleLock, unit } = useSize();
    const finalWidth = roundDimension(unit, width ?? 0);
    const finalHeight = roundDimension(unit, height ?? 0);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex max-w-full items-end gap-2 sm:flex justify-between">
                <div className="flex flex-col min-w-0 gap-2 max-w-xl">
                    <div className="capitalize" data-testid="resize-settings-by-dimensions-width-label">
                        <Translate keyName="width" />
                    </div>
                    <Input
                        type="number"
                        acceptFloat={unit !== "pixels"}
                        value={finalWidth || ""}
                        min={0}
                        onChange={handleWidthChange}
                        data-testid="resize-settings-by-dimensions-width"
                    />
                </div>

                <div className="flex flex-col min-w-0 gap-2 justify-between h-full max-w-xl">
                    <div
                        className="flex items-center justify-between"
                        data-testid="resize-settings-by-dimensions-height-label"
                    >
                        <div className="capitalize">
                            <Translate keyName="height" />
                        </div>
                    </div>
                    <Input
                        type="number"
                        acceptFloat={unit !== "pixels"}
                        value={finalHeight || ""}
                        min={0}
                        onChange={handleHeightChange}
                        data-testid="resize-settings-by-dimensions-height"
                    />
                </div>
            </div>
            <div className="flex justify-between items-center">
                <Checkbox
                    defaultIsChecked={isLocked}
                    handleChange={toggleLock}
                    label={capitalize(translateFunc("lock-aspect-ratio"))}
                    testId="lock-container"
                />
            </div>
        </div>
    );
};
